"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_2 = require("@emotion/react");
const configure_store_1 = __importDefault(require("src/redux/store/configure-store"));
const selectors_1 = require("src/redux/sagas/selectors");
const survey_1 = require("src/utils/survey");
const client_config_1 = __importDefault(require("src/utils/client-config"));
const root_1 = require("src/utils/root");
const css_embed_customizer_1 = __importDefault(require("src/components/css-embed-customizer"));
const variables_styles_1 = __importDefault(require("src/styles/variables.styles"));
class Survey extends react_1.default.Component {
    constructor(props) {
        super(props);
        const { surveyConfig, rootSaga, location, rootService } = props;
        this.location = location !== null && location !== void 0 ? location : window.location;
        this.store = (0, configure_store_1.default)({
            location: this.location,
            rootSaga,
            surveyConfig,
            rootService
        });
        const isHaveUxQuestions = (0, selectors_1.getIsHaveUxQuestions)(this.store.getState());
        this.metrika = (0, client_config_1.default)(Object.assign(Object.assign({}, this.location), { isHaveUxQuestions })).metrika;
    }
    render() {
        const { size, AppComponent, PageComponent, PagesComponent, ProgressBarComponent, NextBtnComponent, SkipBtnComponent, rootService } = this.props;
        return ((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(react_redux_1.Provider, Object.assign({ store: this.store }, { children: (0, jsx_runtime_1.jsx)(root_1.RootProvider, Object.assign({ value: rootService }, { children: (0, jsx_runtime_1.jsxs)(css_embed_customizer_1.default, { children: [(0, jsx_runtime_1.jsx)(react_2.Global, { styles: variables_styles_1.default }), (0, jsx_runtime_1.jsx)(AppComponent, Object.assign({ ProgressBarComponent: ProgressBarComponent, 
                                // @ts-expect-error TS(2322): Type '{ children: Element; PaginatorComponent: () ... Remove this comment to see the full error message
                                initialSize: size }, { children: (0, jsx_runtime_1.jsx)(PagesComponent, { slug: (0, survey_1.getSlugFromPathname)({ pathname: this.location.pathname }), queryString: this.location.search.substring(1), PageComponent: PageComponent, 
                                    // @ts-expect-error TS(2322): Type '(props: { label?: string; onClick: any; size... Remove this comment to see the full error message
                                    NextBtnComponent: NextBtnComponent, 
                                    // @ts-expect-error TS(2322): Type '(props: { onClick: any; mix: any; size: any;... Remove this comment to see the full error message
                                    SkipBtnComponent: SkipBtnComponent }) }))] }) })) })) }));
    }
}
exports.default = Survey;
